import React, { useEffect, useState } from 'react';
import { DelinquencyReport } from '../../../../shared/reports/Financial/Delinquency';
import api from '../../../../services/api';
import { IFinancial } from '../../../../shared/interfaces';
import { useToast } from '../../../../hooks/toast';
import {
  AButton,
  PageIntro,
  PageLayout,
  PagePanel,
} from '../../../../components';
import { ArrowLeftOutlined, PrinterOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const DelinquencyPage: React.FC = () => {
  const [data, setData] = useState<IFinancial[]>([]);
  const { addToast } = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    api
      .get('/financials/reports/delinquency')
      .then((response) => {
        setData(response.data);
      })
      .catch(() => {
        addToast({
          type: 'error',
          title: 'Erro',
          description: 'Erro ao carregar relatório',
        });
      });
  }, [addToast]);

  return (
    <PageLayout>
      <PageIntro
        badge="Relatórios"
        icon={<PrinterOutlined />}
        title="Inadimplência"
        description="Acompanhe os títulos em atraso em uma visualização consistente com o restante das páginas financeiras."
        actions={
          <AButton
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate('/financials')}
          >
            Voltar
          </AButton>
        }
      />
      <PagePanel>
        <div style={{ flex: 1 }}>
          <DelinquencyReport financials={data} />
        </div>
      </PagePanel>
    </PageLayout>
  );
};
export default DelinquencyPage;
